import * as THREE from "three";
import EventEmitter from "./EventEmitter";
import { GLTFLoader,DRACOLoader } from "three/examples/jsm/Addons.js";

export default class Resources extends EventEmitter {

    constructor(sources) {
        super()

        // Options
        this.sources = sources;

        // Setup
        this.items = {};
        this.toLoad = this.sources.length;
        this.loaded = 0;

        this.setLoaders()
        this.startLoading(sources);
    }

    setLoaders(){
        this.loaders = {};
        this.loaders.gltfLoader = new GLTFLoader();
        this.loaders.dracoLoader = new DRACOLoader();
        this.loaders.dracoLoader.setDecoderPath( '/draco/' );
        this.loaders.dracoLoader.preload()
        this.loaders.textureLoader = new THREE.TextureLoader();
        this.loaders.gltfLoader.setDRACOLoader(this.loaders.dracoLoader);
        // this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader();
        // this.loaders.exrLoader = new EXRLoader();
    }

    startLoading(sources) {

        // Loop through each source
        for(const source of sources){
            if(source.type === 'gltfModel'){
                this.loaders.gltfLoader.load(source.path, (file) => {
                    this.sourceLoaded(source, file);
                });
            } else if(source.type === 'texture'){
                this.loaders.textureLoader.load(source.path, (file) => {
                    // file.flipY = false; // Prevents the texture from being flipped vertically
                    this.sourceLoaded(source, file);
                });
            } else if(source.type === 'dracoModel'){
                this.loaders.gltfLoader.load(source.path, (file) => {
                    this.sourceLoaded(source, file);
                });
            }
            // else if(source.type === 'cubeTexture'){
            //     this.loaders.cubeTextureLoader.load(source.path, (file) => {
            //         this.sourceLoaded(source, file);
            //     });
            // } else if(source.type === 'exrTexture'){
            //     this.loaders.exrLoader.load(source.path, (file) => {
            //         this.sourceLoaded(source, file);
            //     });
            // }
        }
    }

    sourceLoaded(source, file) {
        this.items[source.name] = file;
        this.loaded++;
        if (this.loaded === this.toLoad) {
            
            this.trigger('ready');
        }
    }
}